














































































































import { Vue, Component } from 'vue-property-decorator'
import { sample, sampleSize } from 'lodash'
import {
  frontHairStyles,
  sideHairStyles,
  rearHairStyles,
  eyeTypes,
  ages,
  featuresA,
  featuresB,
  bustSizes,
  bodyTypes,
} from '@/const'

interface Form {
  frontHairStyles: string[];
  sideHairStyles: string[];
  rearHairStyles: string[];
  eyeTypes: string[];
  featuresA: string[];
  featuresB: string[];
  ages: string[];
  bustSizes: string[];
  bodyTypes: string[];
}

@Component({
  name: 'app',
})
export default class App extends Vue {
  public form: Form = {
    frontHairStyles: [...frontHairStyles],
    sideHairStyles: [...sideHairStyles],
    rearHairStyles: [...rearHairStyles],
    eyeTypes: [...eyeTypes],
    featuresA: [...featuresA],
    featuresB: [...featuresB],
    ages: [...ages],
    bustSizes: [...bustSizes],
    bodyTypes: [...bodyTypes],
  }

  public frontHairStyle = ''
  public sideHairStyle = ''
  public rearHairStyle: string[] = []
  public eyeType = ''
  public featureA: string[] = []
  public featureB: string[] = []
  public age = ''
  public bustSize = ''
  public bodyType = ''

  public frontHairStylesIsIndeterminate = false
  public sideHairStylesIsIndeterminate = false
  public rearHairStylesIsIndeterminate = false
  public featuresAIsIndeterminate = false
  public eyeTypesIsIndeterminate = false
  public featuresBIsIndeterminate = false
  public agesIsIndeterminate = false
  public bustSizesIsIndeterminate = false
  public bodyTypesIsIndeterminate = false

  public checkAllFrontHairStyles = true
  public checkAllSideHairStyles = true
  public checkAllRearHairStyles = true
  public checkAllFeaturesA = true
  public checkAllEyeTypes = true
  public checkAllFeaturesB = true
  public checkAllAges = true
  public checkAllBustSizes = true
  public checkAllBodyTypes = true

  public handleCheckAllFrontHairStylesChange (value: string[]) {
    this.form.frontHairStyles = value ? frontHairStyles : [];
    this.frontHairStylesIsIndeterminate = false;
  }
  public handleCheckAllSideHairStylesChange (value: string[]) {
    this.form.sideHairStyles = value ? sideHairStyles : [];
    this.sideHairStylesIsIndeterminate = false;
  }
  public handleCheckAllRearHairStylesChange (value: string[]) {
    this.form.rearHairStyles = value ? rearHairStyles : [];
    this.rearHairStylesIsIndeterminate = false;
  }
  public handleCheckAllFeaturesAChange (value: string[]) {
    this.form.featuresA = value ? featuresA : [];
    this.featuresAIsIndeterminate = false;
  }
  public handleCheckAllEyeTypesChange (value: string[]) {
    this.form.eyeTypes = value ? eyeTypes : [];
    this.eyeTypesIsIndeterminate = false;
  }
  public handleCheckAllFeaturesBChange (value: string[]) {
    this.form.featuresB = value ? featuresB : [];
    this.featuresBIsIndeterminate = false;
  }
  public handleCheckAllAgesChange (value: string[]) {
    this.form.ages = value ? ages : [];
    this.agesIsIndeterminate = false;
  }
  public handleCheckAllBustSizesChange (value: string[]) {
    this.form.bustSizes = value ? bustSizes : [];
    this.bustSizesIsIndeterminate = false;
  }
  public handleCheckAllBodyTypesChange(value: string[]) {
    this.form.bodyTypes = value ? bodyTypes : [];
    this.bodyTypesIsIndeterminate = false;
  }

  public handleCheckedFrontHairStylesIsIndeterminateChange (value: string[]) {
    const checkedCount = value.length;
    this.checkAllFrontHairStyles = checkedCount === frontHairStyles.length
    this.frontHairStylesIsIndeterminate = checkedCount > 0 && checkedCount < frontHairStyles.length
  }
  public handleCheckedSideHairStylesIsIndeterminateChange (value: string[]) {
    const checkedCount = value.length;
    this.checkAllSideHairStyles = checkedCount === sideHairStyles.length
    this.sideHairStylesIsIndeterminate = checkedCount > 0 && checkedCount < sideHairStyles.length
  }
  public handleCheckedRearHairStylesIsIndeterminateChange (value: string[]) {
    const checkedCount = value.length;
    this.checkAllRearHairStyles = checkedCount === rearHairStyles.length
    this.rearHairStylesIsIndeterminate = checkedCount > 0 && checkedCount < rearHairStyles.length
  }
  public handleCheckedFeaturesAIsIndeterminateChange (value: string[]) {
    const checkedCount = value.length;
    this.checkAllFeaturesA = checkedCount === featuresA.length
    this.featuresAIsIndeterminate = checkedCount > 0 && checkedCount < featuresA.length
  }
  public handleCheckedEyeTypesIsIndeterminateChange (value: string[]) {
    const checkedCount = value.length;
    this.checkAllEyeTypes = checkedCount === eyeTypes.length
    this.eyeTypesIsIndeterminate = checkedCount > 0 && checkedCount < eyeTypes.length
  }
  public handleCheckedFeaturesBIsIndeterminateChange (value: string[]) {
    const checkedCount = value.length;
    this.checkAllFeaturesB = checkedCount === featuresB.length
    this.featuresBIsIndeterminate = checkedCount > 0 && checkedCount < featuresB.length
  }
  public handleCheckedAgesIsIndeterminateChange (value: string[]) {
    const checkedCount = value.length;
    this.checkAllAges = checkedCount === ages.length
    this.agesIsIndeterminate = checkedCount > 0 && checkedCount < ages.length
  }
  public handleCheckedBustSizesIsIndeterminateChange (value: string[]) {
    const checkedCount = value.length;
    this.checkAllBustSizes = checkedCount === bustSizes.length
    this.bustSizesIsIndeterminate = checkedCount > 0 && checkedCount < bustSizes.length
  }
  public handleCheckedBodyTypesIsIndeterminateChange (value: string[]) {
    const checkedCount = value.length;
    this.checkAllBodyTypes = checkedCount === bodyTypes.length
    this.bodyTypesIsIndeterminate = checkedCount > 0 && checkedCount < bodyTypes.length
  }

  public get frontHairStyles () {
     return frontHairStyles
  }

  public get sideHairStyles () {
     return sideHairStyles
  }

  public get rearHairStyles () {
     return rearHairStyles
  }

  public get eyeTypes () {
     return eyeTypes
  }

  public get featuresA () {
     return featuresA
  }

  public get featuresB () {
     return featuresB
  }

  public get ages () {
     return ages
  }

  public get bustSizes () {
     return bustSizes
  }

  public get bodyTypes () {
     return bodyTypes
  }

  public mounted () {
    this.shuffle()
  }

  public shuffle () {
    this.frontHairStyle = sample(this.form.frontHairStyles) || ''
    this.sideHairStyle = sample(this.form.sideHairStyles) || ''
    this.rearHairStyle = sampleSize(this.form.rearHairStyles, 2) || ''
    this.eyeType = sample(this.form.eyeTypes) || ''
    this.featureA = sampleSize(this.form.featuresA, 2) || ''
    this.featureB = sampleSize(this.form.featuresB, 2) || ''
    this.age = sample(this.form.ages) || ''
    this.bustSize = sample(this.form.bustSizes) || ''
    this.bodyType = sample(this.form.bodyTypes) || ''
  }
}
